import React, {useEffect} from "react";
import {CategoryModel} from "../../../models/category.model";
import {Collapse, Grid, List, ListItemText} from "@mui/material";
import {ExpandLess, ExpandMore} from "@material-ui/icons";
import {StyledInput} from "../../form/input";
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import {StyledSmallButton} from "../../ui-base/small-button";
import {ChartModal} from "../../../pages/publisher/chart-modal";
import {useTranslation} from "react-i18next";

export const CategoriesFillData: React.FC<{categoriesSelected: CategoryModel[], returnNewCategories: Function, returnTotalBooks: Function, initTotal?: number, extendErrorDetails?: boolean, totalBooksError: boolean}> = ({categoriesSelected, returnNewCategories, returnTotalBooks, initTotal, extendErrorDetails = false, totalBooksError}) => {
    const [categories, setCategories] = React.useState<CategoryModel[]>([]);
    const [chartModal, setChartModal] = React.useState(false);
    const [categoriesToModal, setCategoriesToModal] = React.useState([]);
    const [totalBooks, setTotalBooks] = React.useState(0);
    const [totalMainCategoryPercent, setTotalMainCategoryPercent] = React.useState(0);
    const { t } = useTranslation(['publisher', 'common']);

    useEffect(() => {
        const tmpCategories = JSON.parse(JSON.stringify(categoriesSelected));

        const categoriesReady = tmpCategories.filter((category) => {
            return !category.parent_code;
        }).map(category => {
            const oldCategory = categories.find((cat) => cat.code === category.code);

            if (oldCategory) {
                category.open = oldCategory.open;
                category.count = oldCategory.count;
            } else {
                category.open = false;
                category.count = !category.count ? 0 : category.count;
            }

            category.children = [];
            return category;
        });

        const categoriesWithParent = tmpCategories.filter((category) => category.parent_code && category.parent_code.length === 1);

        categoriesWithParent.forEach((category: CategoryModel) => {
            const oldMainCategory = categories.find((cat) => cat.code === category.parent_code);
            if (oldMainCategory && oldMainCategory.children.length > 0) {
                const oldCategory = oldMainCategory.children.find((child) => child.code === category.code);

                if (oldCategory) {
                    category.count = oldCategory.count;
                } else {
                    category.count = !category.count ? 0 : category.count;
                }
            } else {
                category.count = !category.count ? 0 : category.count;
            }

            let parent: CategoryModel = categoriesReady.find((res) => res.code === category.parent_code);

            if (parent) {
                if (parent.children.indexOf(category) === -1) {
                    parent.children.push(category);
                }
            }
        });

        let totalMainCategory = 0;
        categoriesReady.forEach(mainCategory => {
            totalMainCategory = Math.round(((totalMainCategory + mainCategory.count) + Number.EPSILON) * 100) / 100;

            let totalCategory = 0;
            mainCategory.children.forEach(category => {
                const tmpCount = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                if (tmpCount > 100) {
                    const diff = tmpCount - 100;
                    category.count = Math.round(((category.count - diff) + Number.EPSILON) * 100) / 100;
                    totalCategory = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                } else {
                    totalCategory = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                }
            });

            mainCategory.totalChildrenCount = totalCategory;
        });

        setTotalMainCategoryPercent(totalMainCategory);
        setCategories(categoriesReady);
        returnNewCategories(categoriesReady);
        // eslint-disable-next-line
    }, [categoriesSelected]);

    useEffect(() => {
        if (initTotal) {
            setTotalBooks(initTotal);
            returnTotalBooks(initTotal);
        }
        // eslint-disable-next-line
    }, [initTotal]);

    useEffect(() => {
        if (extendErrorDetails) {
            setCategories((currState) => {
                return currState.map((category) => {
                    return {
                        ...category,
                        open: true
                    }
                });
            })
        }
    }, [extendErrorDetails])

    const toggleGroup = (index: number) => {
        const newCategories = JSON.parse(JSON.stringify(categories));
        newCategories[index].open = !newCategories[index].open;
        setCategories(newCategories);
    }

    const setNewCountValue = (category: CategoryModel, index: number, value: string) => {
        if (value) {
            const newValue = Math.min(Math.max(parseFloat(value), 0), 100)
            const newCategories = JSON.parse(JSON.stringify(categories));

            if (!category.parent_code) {
                newCategories[index].count = newValue;
            } else {
                newCategories.forEach((mainCategory) => {
                    if (mainCategory.code === category.parent_code) {
                        mainCategory.children[index].count = newValue;
                    }
                });
            }

            let totalMainCategory = 0;
            newCategories.forEach(mainCategory => {
                totalMainCategory = Math.round(((totalMainCategory + mainCategory.count) + Number.EPSILON) * 100) / 100;

                let totalCategory = 0;
                mainCategory.children.forEach(category => {
                    const tmpCount = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                    if (tmpCount > 100) {
                        const diff = tmpCount - 100;
                        category.count = Math.round(((category.count - diff) + Number.EPSILON) * 100) / 100;
                        totalCategory = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                    } else {
                        totalCategory = Math.round(((totalCategory + category.count) + Number.EPSILON) * 100) / 100;
                    }
                });

                mainCategory.totalChildrenCount = totalCategory;
            });

            setTotalMainCategoryPercent(totalMainCategory);
            setCategories(newCategories);
            returnNewCategories(newCategories);
        }
    }

    const showChartModal = (categories: CategoryModel[]) => {
        setCategoriesToModal(categories);
        setChartModal(true);
    }

    const updateTotalBooks = (total: string) => {
        if (total) {
            const newTotal = Math.max(parseInt(total), 1);
            setTotalBooks(newTotal);
            returnTotalBooks(newTotal);
        }
    }

    return (
        <>
            {/*<Grid container justifyContent={"flex-end"}>*/}
            {/*    <p style={{width: '150px', textAlign: 'center'}}>Ilość wydawanych książek</p>*/}
            {/*</Grid>*/}
            <List
                sx={{ width: '100%', bgcolor: 'background.paper' }}
                component="nav"
                aria-labelledby="nested-list-subheader"
                subheader={''}
            >
                <Grid container direction={"row"} justifyContent={"space-between"} alignItems={"center"} spacing={1} style={{marginBottom: '15px'}}>
                    <Grid item>
                        <StyledInput id={'total-books'} label={t('createPublisherProfile.booksCount') + '*'}
                                     smallInput={true} value={totalBooks} type={"number"} onChange={(e) => {updateTotalBooks(e.target.value)}}
                                error={totalBooksError && (!totalBooks || totalBooks <= 0)}
                        />
                    </Grid>

                    <Grid item>
                        <StyledSmallButton type={"button"} onClick={() => {showChartModal(categories);}} style={{width: '90px'}} color={"secondary"}>
                            <DonutLargeIcon/>
                        </StyledSmallButton>
                    </Grid>
                </Grid>
                {categories.map((mainCategory, index) =>
                    <Grid key={index}>
                        <Grid container direction={"row"} alignItems={"center"} spacing={1}>
                            {mainCategory.children && mainCategory.children.length > 0 &&
                                <Grid item onClick={() => {
                                    toggleGroup(index);
                                }} style={{cursor: 'pointer'}}>
                                    {mainCategory.open ? <ExpandLess style={{color: (mainCategory.totalChildrenCount < 99.5 ? '#f44336' : 'inherit')}} /> : <ExpandMore style={{color: (mainCategory.totalChildrenCount < 99.5 ? '#f44336' : 'inherit')}} />}
                                </Grid>
                            }

                            <Grid item xs container direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                                <Grid item>
                                    <ListItemText primary={mainCategory.name}/>
                                </Grid>

                                <Grid item style={{width: '110px'}}>
                                    <StyledInput id={mainCategory.name} label={''} smallInput={true} value={mainCategory.count} type={"percent"} onChange={(e) => setNewCountValue(mainCategory, index, e.target.value)} error={totalMainCategoryPercent < 99.5}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Collapse in={mainCategory.open} timeout="auto" unmountOnExit>
                            <hr/>
                            <List component="div" disablePadding style={{paddingLeft: '35px'}}>
                                <Grid container direction={"row"} justifyContent={"flex-end"} alignItems={"center"}>
                                    <StyledSmallButton type={"button"} onClick={() => {showChartModal(mainCategory.children);}} style={{width: '90px', marginRight: '5px', marginBottom: '5px'}}>
                                        <DonutLargeIcon/>
                                    </StyledSmallButton>
                                </Grid>
                                {mainCategory.children.map((category, index: number) =>
                                    <Grid container direction={"row"} justifyContent={"space-between"} alignItems={"center"} key={index}>
                                        <Grid item>
                                            <ListItemText primary={category.name}/>
                                        </Grid>

                                        <Grid item style={{width: '110px', marginRight: '4px'}}>
                                            <StyledInput id={mainCategory.name} label={''} smallInput={true} value={category.count} type={"percent"} onChange={(e) => setNewCountValue(category, index, e.target.value)} error={mainCategory.totalChildrenCount < 99.5}/>
                                        </Grid>
                                    </Grid>
                                )}
                            </List>
                            <hr/>
                        </Collapse>
                    </Grid>
                )}
            </List>
            <ChartModal open={chartModal} setOpen={setChartModal} categories={categoriesToModal}/>
        </>
    )
}
